import { createSlice } from "@reduxjs/toolkit";

export const initialAuthSession = {
  cartType: 0,
  totalCart: [],
  activeShopHash: { id: "", location: "", cartType: 0, shop: "", gstDetail: "" },
  listShopHash: [],
  userEmail: "",
  apiToken: "",
  userName: "",
  roles: {},
  otherRoles: {},
  featureRoleDefinitions: {},
  otherRoleDefinitions: [],
  companyName: "",
  companyWebAddress: "",
  companyMail: "",
  validity: "",
  startDate: "",
  originalStartDate: "",
  employeeType: "",
  pointMethod: { pointDenom: 0, pointDenomVal: 0, pointValue: 0, pointRealCostPer: 0 },
  packages: {},
  onlinePayMethod: [],
  homeDelvMethod: [],
  pImg: "",
  offlineLogin: false,
  firstTimeLogin: false,
  loggedIn: false,
  offlineIpSet: false,
  offlineIp: "",
  defScreen: 7,
  defBalanceType: "Self",
  defInactitivityTime: -1,
  quickBill: false,
  kotCopiesAllowed: false,
  defBillUi: 1,
  isChef: false,
  openKitchenAfterLogin: false,
  kitchenNotificationTray: false,
  kitchenNotificationSound: false,
};

const authSessionSlice = createSlice({
  name: "authSession",
  initialState: initialAuthSession,
  reducers: {
    replaceAuthSession: (_state, action) => ({ ...initialAuthSession, ...action.payload }),
    updateAuthSession: (state, action) => Object.assign(state, action.payload),
    clearAuthSession: () => ({ ...initialAuthSession }),
  },
});

export const { replaceAuthSession, updateAuthSession, clearAuthSession } = authSessionSlice.actions;
export const authSessionReducer = authSessionSlice.reducer;
export const selectAuthSession = state => state.authSession;
